export const PregledNosilcev = {
  data () {
    return {
      seznamStroskovnihNosilcev: [],
      podatkiStroskovniNosilec: []
    }
  },
  methods: {
    PridobiNosilce (prenParametri) {
      if (this.izbranid !== '' && typeof this.izbranid !== 'undefined') {
        let param = ['idStranka=' + this.izbranid]
        this.clientAgent.postWsRequest(this,
          '/mercury/nosilci/nosilci?',
          param,
          prenParametri,
          'SetNosilci',
          'ErrPregledNosilce')
      }
    },
    SetNosilci (podatki, prenParametri) {
      let seznamStrNos = []
      let podatkiStroskovniNosilec = podatki.data
      for (let i = 0; i < podatkiStroskovniNosilec.length; i++) {
        seznamStrNos.push(podatkiStroskovniNosilec[i])
      }
      let vmesnik = prenParametri.vmesnik
      vmesnik.SetSeznamStroskovnihNosilcev(prenParametri, seznamStrNos)
    },
    ErrPregledNosilce (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/GlobalnoTelefonija/PregledNosilcev.js